import { render, staticRenderFns } from "./batchInsuranceModal.vue?vue&type=template&id=65ececef&scoped=true"
import script from "./batchInsuranceModal.vue?vue&type=script&lang=js"
export * from "./batchInsuranceModal.vue?vue&type=script&lang=js"
import style0 from "./batchInsuranceModal.vue?vue&type=style&index=0&id=65ececef&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ececef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65ececef')) {
      api.createRecord('65ececef', component.options)
    } else {
      api.reload('65ececef', component.options)
    }
    module.hot.accept("./batchInsuranceModal.vue?vue&type=template&id=65ececef&scoped=true", function () {
      api.rerender('65ececef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/groupOrderManage/batchInsurance/batchInsuranceModal.vue"
export default component.exports